export default __webpack_public_path__ + "static/media/warning--divided-highway--g2.c8b40ab4.png";